export enum CalendarFormat {
  STANDARD_GREGORIAN = 'STANDARD_GREGORIAN',
  ISO_8601 = 'ISO_8601'
}
